<ul class="flex flex-row text-sm text-president-400" *transloco="let t">
  <li>
    <fa-icon class="mr-2xs text-petrol-300" [icon]="faCheck"></fa-icon>
    {{ t('buildigoValueCheckmarks.0.text') }}
  </li>
  <li class="ml-sm">
    <fa-icon class="mr-2xs text-purple-300" [icon]="faCheck"></fa-icon>
    {{ t('buildigoValueCheckmarks.1.text') }}
  </li>
  <li class="ml-sm">
    <fa-icon class="mr-2xs text-gold-300" [icon]="faCheck"></fa-icon>
    {{ t('buildigoValueCheckmarks.2.text') }}
  </li>
  <li class="ml-sm">
    <fa-icon class="mr-2xs text-rivergreen-500" [icon]="faCheck"></fa-icon>
    {{ t('buildigoValueCheckmarks.3.text') }}
  </li>
</ul>
